<blockable-div id="commercial-facility-details-container" #details>
  <app-progress-spinner [enabled]="!facility()" />
  <p-blockUI [blocked]="saving() || isLoading()" [target]="details" />
  @if (facility(); as facility) {
    <div id="commercial-facility-details">
      @if (formState(); as form) {
        @let writeAccess =
          !isHistoricalRecord() && (facility.id ? canEdit() : canCreate());
        <div class="commercial-facility-tabs-shell">
          <div class="commercial-facility-actions">
            @if (actions().length > 0) {
              <p-select
                #dd
                [options]="actions()"
                [(ngModel)]="selectedAction"
                (onChange)="actionEvent($event, dd)"
                appendTo="body"
                class="commercial-facility-action-select"
              />
            }
            @if (writeAccess) {
              <app-progress-spinner [enabled]="saving()" />
              <button
                pButton
                id="save-btn"
                label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
                icon="fa fa-fw fa-save"
                (click)="saveFacility()"
                [disabled]="!formDirty() || saving()"
              ></button>
            }
          </div>
          <p-tabs value="info" id="commercial-facility-tabs">
            <p-tablist>
              <p-tab value="info">{{
                'COMMERCIAL_SERVICES.LABEL.FACILITY_INFO_TAB' | translate
              }}</p-tab>
              <p-tab value="contacts">
                {{ 'COMMERCIAL_SERVICES.LABEL.CONTACTS_TAB' | translate }}
                <span class="tab-count">{{
                  form.get('commercialContactIds')?.value?.length ?? 0
                }}</span>
              </p-tab>
              <p-tab value="notepad">{{
                'COMMERCIAL_SERVICES.LABEL.NOTEPAD_TAB' | translate
              }}</p-tab>
            </p-tablist>
            <p-tabpanels>
              <p-tabpanel value="info">
                <p-scrollPanel class="commercial-facility-scroll-panel">
                  <app-commercial-facility-form
                    [form]="form"
                    [facility]="facility"
                    [availableCompanies]="companyOptions()"
                    [availableFacilityTypes]="availableFacilityTypes()"
                    [availableOperatingAreas]="availableOperatingAreas()"
                    [availableMarketAreas]="availableMarketAreas()"
                    [availableAORs]="aorOptions()"
                    [availableBalancingTypes]="availableBalancingTypes()"
                    [availableMCFacilities]="availableMCFacilities()"
                    [aors]="aors()"
                    [canOpenContacts]="canViewGcContacts()"
                    [canOpenMcFacility]="canViewMcFacilities()"
                    [validationMessages]="validationMessages"
                    (operatingAreaChanged)="onOperatingAreaChange($event)"
                    (openMcFacility)="openMcFacility($event)"
                    (openContact)="openGcContact($event)"
                  />
                </p-scrollPanel>
              </p-tabpanel>
              <p-tabpanel value="contacts">
                <p-scrollPanel class="commercial-facility-scroll-panel">
                  <app-commercial-facility-contacts
                    [control]="form.get('commercialContactIds')"
                    [facility]="facility"
                    [contacts]="commercialContacts()"
                    [isHistoricalRecord]="isHistoricalRecord()"
                    [writeAccess]="writeAccess"
                    [canOpenContacts]="canViewCommercialContacts()"
                    (openContact)="openCommercialContact($event)"
                  />
                </p-scrollPanel>
              </p-tabpanel>
              <p-tabpanel value="notepad">
                <p-scrollPanel class="commercial-facility-scroll-panel">
                  <p class="commercial-facility-notepad-placeholder">
                    {{
                      'COMMERCIAL_SERVICES.LABEL.NOTEPAD_COMING_SOON'
                        | translate
                    }}
                  </p>
                </p-scrollPanel>
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>
        </div>
      }
    </div>
  }
</blockable-div>
